var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 129,
    height: 133
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "M-48-20h225v1025H-48z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#C62A56",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.392
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.72 2.04v123.945M100.545 22.817v41.296M29.296 64.152V105.4M100.439 64.22l-71.213 41.305M100.347 22.865 29.232 64.113M64.575 2.072l-35.533 20.61M64.498 125.985l-35.273-20.46M64.649 84.68 29.226 64.134M100.387 22.769 64.649 2.04M100.473 64.113 29.042 22.682"
  })))));
};
export default SvgLogo;